import styled from 'styled-components';

import ChevronIcon from 'shared/components/chevron-icon';
import tinycolor from 'tinycolor2';

import { Typography } from 'src/typography';

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`;

export const SectionLabel = styled(Typography.Label)`
  color: var(--dcm-wallet-section-label-color, ${({ theme }) => theme.colors.grey[45]});
  letter-spacing: 1px;
  white-space: nowrap;
`;

export const SectionRule = styled.span`
  background: var(--dcm-wallet-section-rule-color, ${({ theme }) => theme.colors.grey[90]});
  flex-grow: 1;
  height: 1px;
`;

export const AddBankCard = styled.div`
  border: 1px solid var(--dcm-wallet-add-bank-border-color, ${({ theme }) => theme.colors.grey[90]});
  border-radius: var(--dcm-wallet-add-bank-border-radius, 8px);
  padding: 16px 0;
`;

export const AddBankCardButton = styled.button`
  background: var(--dcm-wallet-add-bank-bg, ${({ theme }) => theme.colors.white});
  border: none;
  border-radius: var(--dcm-wallet-add-bank-border-radius, 8px);
  align-items: center;
  cursor: pointer;
  display: flex;
  gap: 12px;
  text-align: left;
  width: 100%;
  padding: 0 16px;
`;

export const AddBankIconSquare = styled.span`
  align-items: center;
  background: var(
    --dcm-wallet-add-bank-icon-bg,
    ${({ theme }) => tinycolor.mix(theme.customized.colors.buttonsLinks, '#fff', 90)}
  );
  border: 1px dotted
    var(
      --dcm-wallet-add-bank-icon-border-color,
      ${({ theme }) => tinycolor.mix(theme.customized.colors.buttonsLinks, '#fff', 55)}
    );
  border-radius: var(--dcm-wallet-add-bank-icon-border-radius, 8px);
  color: var(--dcm-wallet-add-bank-icon-color, ${({ theme }) => theme.customized.colors.buttonsLinks});
  display: flex;
  flex-shrink: 0;
  height: 40px;
  justify-content: center;
  width: 40px;
`;

export const AddBankText = styled.span`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 2px;
`;

export const AddBankTitle = styled(Typography.Body)`
  color: var(--dcm-color-text-primary, ${({ theme }) => theme.colors.primaryBlack});
  line-height: 16px;
`;

export const AddBankSubtitle = styled(Typography.Body)`
  color: var(--dcm-wallet-add-bank-subtitle-color, ${({ theme }) => theme.colors.grey[45]});
  line-height: 18px;
`;

export const ChevronRight = styled(ChevronIcon)`
  color: var(--dcm-wallet-add-bank-chevron-color, ${({ theme }) => theme.colors.grey[45]});
  fill: currentColor;
  flex-shrink: 0;
  transform: rotate(-90deg);
`;

export const MarqueeWrapper = styled.div`
  margin-top: 16px;
  overflow: hidden;
  width: 100%;
`;
